module.exports = __webpack_public_path__ + "static/DasaSans-Semibold-1df878f696b941afd19762491139f68b.ttf";